import Image from 'next/image'

import { mq } from '@/styles/size'

import { SITE_REFERENCE } from './constants'

function SiteReference(): React.ReactElement {
  return (
    <section
      css={(theme) =>
        mq({
          width: theme.size.width[90],
          maxWidth: theme.size.width[900],
          height: 'auto',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          flexFlow: 'column nowrap',
          margin: 'auto',
          padding: '113px 0 106px 0',
          position: 'relative',
        })
      }
    >
      <h1
        className="section-title"
        css={(theme) =>
          mq({
            color: theme.colors.secondary[900],
            fontSize: [
              'var(--fs-500)',
              'var(--fs-500)',
              'var(--fs-570)',
              'var(--fs-600)',
            ],
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: '1px',
            margin: '0 0 40px 0',
            textAlign: 'center',
          })
        }
      >
        ลูกค้าที่ไว้วางใจเรา
      </h1>
      <div
        className="image-block"
        css={mq({
          display: 'flex',
          flexFlow: 'row wrap',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: ['320px', '400px', '600px', '1000px'],
        })}
      >
        {SITE_REFERENCE.map((site, index) => {
          return (
            <figure
              key={`${index}`}
              className="image-container"
              css={mq({
                margin: ['12px', '16px', '20px'],
                width: [
                  `${0.5 * site.width}px`,
                  `${0.7 * site.width}px`,
                  `${site.width}px`,
                ],
                height: [
                  `${0.5 * site.height}px`,
                  `${0.7 * site.height}px`,
                  `${site.height}px`,
                ],
                position: 'relative',
                '& > *': {
                  position: 'absolute !important',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                },
              })}
            >
              <Image
                src={site.src}
                alt={site.alt}
                layout="fill"
                priority
                sizes="30vw"
              />
            </figure>
          )
        })}
      </div>
    </section>
  )
}

export default SiteReference
